console.log("[discount-badge] Script loaded");

// -----------------------------------------------------
// Parse REAL product JSON from <script id="product-json">
// -----------------------------------------------------
const PRODUCT_DATA = (() => {
  try {
    const el = document.querySelector("#product-json");
    if (!el) {
      console.error("[discount-badge] ❌ No #product-json found");
      return null;
    }
    return JSON.parse(el.textContent);
  } catch (err) {
    console.error("[discount-badge] ❌ Error parsing #product-json", err);
    return null;
  }
})();

if (!PRODUCT_DATA) {
  console.error("[discount-badge] ❌ PRODUCT_DATA NOT AVAILABLE");
}

// -----------------------------------------------------
// Helper: Get variant by ID from parsed product JSON
// -----------------------------------------------------
function getVariantById(id) {
  if (!PRODUCT_DATA || !PRODUCT_DATA.variants) return null;
  return PRODUCT_DATA.variants.find(v => String(v.id) === String(id)) || null;
}

// -----------------------------------------------------
// Update discount badge dynamically based on variant
// -----------------------------------------------------
function updateDiscountBadge(variantId) {
  console.log("[discount-badge] Updating badge for variant:", variantId);

  const badge = document.querySelector(".price--large .custom-product-discount-badge");

  if (!badge) {
    console.error("[discount-badge] ❌ Badge .custom-product-discount-badge not found");
    return;
  }

  const variant = getVariantById(variantId);

  if (!variant) {
    console.error("[discount-badge] ❌ Variant not found in product JSON:", variantId);
    badge.style.display = "none";
    return;
  }

  console.log("[discount-badge] Variant found:", variant);

  const rawPrice = variant.price;
  const rawCompare = variant.compare_at_price;

  console.log("[discount-badge] rawPrice:", rawPrice);
  console.log("[discount-badge] rawCompare:", rawCompare);

  // No discount
  if (!rawCompare || rawCompare <= rawPrice) {
    console.log("[discount-badge] No discount → hiding badge");
    badge.style.display = "none";
    return;
  }

  const price = rawPrice / 100;
  const compareAt = rawCompare / 100;

  const discount = compareAt - price;
  const percent = Math.round((discount * 100) / compareAt);

  console.log("[discount-badge] %:", percent);

  badge.textContent = `SALE ${percent}% OFF`;
  badge.style.display = "inline-block";

  console.log("[discount-badge] Badge updated ✔️");
}

// -----------------------------------------------------
// Detect variant changes via <input name="id">
// (Shopify updates this when user selects a variant)
// -----------------------------------------------------
const variantInput = document.querySelector('input[name="id"]');

if (!variantInput) {
  console.error("[discount-badge] ❌ No <input name='id'> found");
} else {
  console.log("[discount-badge] Found variant input:", variantInput);

  const observer = new MutationObserver(() => {
    const variantId = variantInput.value;
    console.log("[discount-badge] Variant changed →", variantId);
    updateDiscountBadge(variantId);
  });

  observer.observe(variantInput, {
    attributes: true,
    attributeFilter: ["value"]
  });

  // Initial execution on page load
  console.log("[discount-badge] Initial load →", variantInput.value);
  updateDiscountBadge(variantInput.value);
}
